import { render, staticRenderFns } from "./ReservationsSingle.vue?vue&type=template&id=2856eb6a"
import script from "./ReservationsSingle.vue?vue&type=script&lang=js"
export * from "./ReservationsSingle.vue?vue&type=script&lang=js"
import style0 from "./ReservationsSingle.vue?vue&type=style&index=0&id=2856eb6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports